import { InjectionToken } from '@angular/core';

/**
 * Generic root API URL token for Suite Life Tools backend services.
 * Provided by the host application (e.g., 'https://api.suitelifetools.com' or staging equivalent).
 */
export const API_URL = new InjectionToken<string>('API_URL');
